<h2 mat-dialog-title class="dialog-title">
  @if(data.hidecancel == false){
  Confirmation
  }@else{
  Information
  }
</h2>

<mat-dialog-content class="dialog-content">
  <div class="icon-container">
    <mat-icon>check_circle</mat-icon>
  </div>

  <p class="message">{{data.message}}<br />
    <!-- <span class="sub-text">This action cannot be undone.</span> -->
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  @if(data.hidecancel == false){
  <button mat-button (click)="onClickNo()">
    Cancel
  </button>
  }

  <button mat-raised-button (click)="onClickYes()">
    OK
  </button>
</mat-dialog-actions>